// Simulated API call
import { LoginRequest, LoginResponse } from '../types/auth';

export const loginAPI = async (data: LoginRequest): Promise<LoginResponse> => {
  if (data.email === 'guest@cardealer.com') {
    return {
      token: 'guest-token',
      user: {
        name: 'Guest User',
        role: 'guest',
      },
    };
  }

  if (data.email === 'user@cardealer.com' && data.password === 'password') {
    return {
      token: 'user-token',
      user: {
        name: 'John Doe',
        role: 'user',
      },
    };
  }

  throw new Error('Invalid credentials');
};
